import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { ArrowRight } from "lucide-react";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user === null) return <div className="min-h-[60vh] grid place-items-center text-zinc-500">Loading…</div>;
  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="text-xs uppercase tracking-[0.3em] text-zinc-500">Sign in</div>
      <h1 className="font-display text-4xl tracking-tighter mt-2">Login to Cure8r</h1>
      <form onSubmit={submit} className="mt-8 space-y-5">
        <div>
          <Label htmlFor="email" className="text-zinc-300">Email</Label>
          <Input
            id="email"
            data-testid="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="mt-1 bg-[#0A0A0A] border-white/10 text-white"
            placeholder="you@school.edu"
          />
        </div>
        <div>
          <Label htmlFor="password" className="text-zinc-300">Password</Label>
          <Input
            id="password"
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="mt-1 bg-[#0A0A0A] border-white/10 text-white"
            placeholder="••••••••"
          />
        </div>
        <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full bg-white text-black hover:bg-zinc-200 h-11">
          {busy ? "Signing in…" : (<><span>Sign In</span><ArrowRight size={16} className="ml-2" /></>)}
        </Button>
      </form>
      <div className="mt-6 pt-6 border-t border-white/10 text-center text-sm">
        <Link to="/signup" data-testid="login-signup-link" className="text-zinc-400 hover:text-white">
          Don't have an account? <span className="text-cyan8r">Sign Up</span>
        </Link>
      </div>
    </div>
  );
}
